AjaxPromise = require 'app/scripts/network/ajax-promise'
Promise = require 'bluebird'
React = require 'react'
_ = require 'underscore'
t = require('app/scripts/views/internal/recup-with-helpers')('billing')

module.exports = class WithSalesTax extends React.Component
  displayName: 'WithSalesTax'

  constructor: ->
    @state =
      taxes: null
      error: null
      loading: true

  UNSAFE_componentWillMount: ->
    @updateSalesTaxes @props

  UNSAFE_componentWillReceiveProps: (nextProps) ->
    @updateSalesTaxes nextProps, @props

  componentWillUnmount: ->
    @taxPromise?.cancel()

  updateSalesTaxes: (nextProps, prevProps = {}) ->
    if !@willTaxesChange nextProps, prevProps
      return

    @setState
      taxes: null
      error: null
      loading: true

    @taxPromise?.cancel()
    @taxPromise = @taxesFromProps nextProps
    .then (taxes) =>
      @setState
        taxes: taxes
        error: null
        loading: false
    .catch (error) =>
      @setState
        taxes: null
        error: error
        loading: false

  willTaxesChange: (nextProps, prevProps) ->
    !_.isEqual(nextProps.subtotals, prevProps.subtotals) ||
        nextProps.dateStandingChange != prevProps.dateStandingChanged ||
        nextProps.getSalesTaxForSubscriberUrl != prevProps.getSalesTaxForSubscriberUrl ||
        nextProps.nextBillingDate != prevProps.nextBillingDate

  taxesFromProps: (nextProps) ->
    { salesTaxForSubscriberUrl, subtotals, nextBillingDate } = nextProps

    taxDate = if nextBillingDate? then new Date(nextBillingDate) else new Date()

    Promise.all subtotals.map (subtotal) =>
      @calculateSalesTax salesTaxForSubscriberUrl, subtotal, taxDate
    .then (responses) -> _.pluck responses, 'tax'

  calculateSalesTax: (url, subtotal, taxDate) ->
    AjaxPromise
      url: url
      data:
        subtotal: subtotal
        taxDate: taxDate.toISOString()

  render: t.renderable ->
    { renderContents, renderError, renderLoading } = @props
    { taxes, error, loading } = @state

    if loading
      renderLoading()
    else if error
      renderError(error)
    else
      renderContents(taxes)
